import { MedplumClient } from "@medplum/core";

import { getResourcesFromBundle, joinReferenceString } from "@/utils/medplum";

export const getPatientRelatedPersons = async (medplum: MedplumClient, clientId: string) => {
  const relatedPersonsResults = await medplum.searchResources("RelatedPerson", {
    patient: joinReferenceString("Patient", clientId),
    _sort: "-_lastUpdated",
  });

  const relatedPersons = getResourcesFromBundle("RelatedPerson", relatedPersonsResults.bundle);

  return relatedPersons;
};
